<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNode5-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNode5-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddNode5-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="AddNode5-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <g transform="translate(75.137 74.75)">
              <path class="AddNode5-st2" d="M-23.61-8.91h-1.73c-1.68,0-3.04,1.36-3.04,3.04l0,0v6.94c0,1.68,1.36,3.04,3.04,3.04h0h1.74c1.68,0,3.04-1.36,3.04-3.04l0,0v-6.94C-20.57-7.55-21.93-8.91-23.61-8.91C-23.61-8.91-23.61-8.91-23.61-8.91z M-23.18,1.07c0,0.24-0.19,0.43-0.43,0.43h-1.73c-0.24,0-0.43-0.19-0.43-0.43v-6.94c0-0.24,0.19-0.43,0.43-0.43h1.74c0.24,0,0.43,0.19,0.43,0.43L-23.18,1.07z"/>
              <path class="AddNode5-st2" d="M-34.03,1.51h-1.3v-9.11c0-0.72-0.58-1.3-1.3-1.3c0,0,0,0,0,0h-2.6c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3c0,0,0,0,0,0h1.3v7.81h-1.3c-0.72,0-1.3,0.58-1.3,1.3s0.58,1.3,1.3,1.3c0,0,0,0,0,0h5.21c0.72,0,1.3-0.58,1.3-1.3S-33.3,1.51-34.03,1.51C-34.02,1.51-34.02,1.51-34.03,1.51z"/>
              <path class="AddNode5-st2" d="M0.69-8.91h-1.73c-1.68,0-3.04,1.36-3.04,3.04l0,0v6.94c0,1.68,1.36,3.04,3.04,3.04l0,0h1.74c1.68,0,3.04-1.36,3.04-3.04l0,0v-6.94C3.73-7.55,2.37-8.91,0.69-8.91C0.69-8.91,0.69-8.91,0.69-8.91z M1.13,1.07c0,0.24-0.19,0.43-0.43,0.43h-1.73c-0.24,0-0.43-0.19-0.43-0.43v-6.94c0-0.24,0.19-0.43,0.43-0.43h1.74c0.24,0,0.43,0.19,0.43,0.43L1.13,1.07z"/>
              <path class="AddNode5-st2" d="M-9.72,1.51h-1.3v-9.11c0-0.72-0.58-1.3-1.3-1.3c0,0,0,0,0,0h-2.6c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3c0,0,0,0,0,0h1.3v7.81h-1.3c-0.72,0-1.3,0.58-1.3,1.3s0.58,1.3,1.3,1.3c0,0,0,0,0,0h5.21c0.72,0,1.3-0.58,1.3-1.3S-9,1.51-9.72,1.51C-9.72,1.51-9.72,1.51-9.72,1.51z"/>
              <path class="AddNode5-st2" d="M-23.61-24.62h-1.73c-1.68,0-3.04,1.36-3.04,3.04v0v6.94c0,1.68,1.36,3.04,3.04,3.04h0h1.74c1.68,0,3.04-1.36,3.04-3.04v0v-6.94C-20.57-23.26-21.93-24.62-23.61-24.62C-23.61-24.62-23.61-24.62-23.61-24.62z M-23.18-14.64c0,0.24-0.19,0.43-0.43,0.43h-1.73c-0.24,0-0.43-0.19-0.43-0.43v-6.94c0-0.24,0.19-0.43,0.43-0.43h1.74c0.24,0,0.43,0.19,0.43,0.43L-23.18-14.64z"/>
              <path class="AddNode5-st2" d="M-34.03-14.2h-1.3v-9.11c0-0.72-0.58-1.3-1.3-1.3c0,0,0,0,0,0h-2.6c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3h1.3v7.81h-1.3c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3h5.21c0.72,0,1.3-0.58,1.3-1.3C-32.72-13.62-33.31-14.2-34.03-14.2z"/>
              <path class="AddNode5-st2" d="M-11.46-24.62h-1.73c-1.68,0-3.04,1.36-3.04,3.04v0v6.94c0,1.68,1.36,3.04,3.04,3.04l0,0h1.74c1.68,0,3.04-1.36,3.04-3.04v0v-6.94C-8.42-23.26-9.78-24.62-11.46-24.62C-11.46-24.62-11.46-24.62-11.46-24.62z M-11.03-14.64c0,0.24-0.19,0.43-0.43,0.43h-1.73c-0.24,0-0.43-0.19-0.43-0.43v-6.94c0-0.24,0.19-0.43,0.43-0.43h1.74c0.24,0,0.43,0.19,0.43,0.43L-11.03-14.64z"/>
              <path class="AddNode5-st2" d="M2.43-14.2h-1.3v-9.11c0-0.72-0.58-1.3-1.3-1.3c0,0,0,0,0,0h-2.6c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3h1.3v7.81h-1.3c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3h5.21c0.72,0,1.3-0.58,1.3-1.3C3.73-13.62,3.15-14.2,2.43-14.2z"/>
              <path class="AddNode5-st2" d="M-35.76-40.33h-1.73c-1.68,0-3.04,1.36-3.04,3.04c0,0,0,0,0,0v6.94c0,1.68,1.36,3.04,3.04,3.04l0,0h1.74c1.68,0,3.04-1.36,3.04-3.04l0,0v-6.94C-32.72-38.97-34.08-40.33-35.76-40.33C-35.76-40.33-35.76-40.33-35.76-40.33zM-35.33-30.35c0,0.24-0.19,0.43-0.43,0.43h-1.73c-0.24,0-0.43-0.19-0.43-0.43v-6.94c0-0.24,0.19-0.43,0.43-0.44c0,0,0,0,0,0h1.74c0.24,0,0.43,0.19,0.43,0.43L-35.33-30.35z"/>
              <path class="AddNode5-st2" d="M-21.87-29.91h-1.3v-9.11c0-0.72-0.58-1.3-1.3-1.3c0,0,0,0,0,0h-2.6c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3c0,0,0,0,0,0h1.3v7.81h-1.3c-0.72,0-1.3,0.58-1.3,1.3s0.58,1.3,1.3,1.3c0,0,0,0,0,0h5.21c0.72,0,1.3-0.58,1.3-1.3C-20.57-29.33-21.15-29.91-21.87-29.91C-21.87-29.91-21.87-29.91-21.87-29.91z"/>
              <path class="AddNode5-st2" d="M0.69-40.33h-1.73c-1.68,0-3.04,1.36-3.04,3.04c0,0,0,0,0,0v6.94c0,1.68,1.36,3.04,3.04,3.04l0,0h1.74c1.68,0,3.04-1.36,3.04-3.04c0,0,0,0,0,0v-6.94C3.73-38.97,2.37-40.33,0.69-40.33C0.69-40.33,0.69-40.33,0.69-40.33zM1.13-30.35c0,0.24-0.19,0.43-0.43,0.43h-1.73c-0.24,0-0.43-0.19-0.43-0.43v-6.94c0-0.24,0.19-0.43,0.43-0.43h1.74c0.24,0,0.43,0.19,0.43,0.43L1.13-30.35z"/>
              <path class="AddNode5-st2" d="M-9.72-29.91h-1.3v-9.11c0-0.72-0.58-1.3-1.3-1.3c0,0,0,0,0,0h-2.6c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3h1.3v7.81h-1.3c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3h5.21c0.72,0,1.3-0.58,1.3-1.3C-8.42-29.33-9-29.91-9.72-29.91C-9.72-29.91-9.72-29.91-9.72-29.91z"/>
            </g>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNode16_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNode16_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddNode5-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNode5_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'


export default {
  name: 'AddNODE16',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  methods: {
    goBack: function () {
      this.$store.commit('setScannedQR', null);
      this.$router.go(-1);
    },
    next: function () {
      this.$router.push('AddNode-SelectHub');
    }
  }
}
</script>

<style>
  .AddNode5-topCurve-wrapper {
    height: 200px;
  }
  .AddNode5-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNode5-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddNode5-st0 {
    fill: #ECECEC;
  }
	.AddNode5-st1 {
    fill: #53636C;
  }
	.AddNode5-st2 {
    fill: #1EA5DE;
  }
</style>
